/**
 * Represents the possible runtime environments
 */
export enum Environment {
  /**
   * Development environment
   */
  Dev = "dev",

  /**
   * Production environment
   */
  Prod = "prod",

  /**
   * Quality assurance (QA) environment
   */
  QA = "qa",

  /**
   * Testing environment
   */
  Test = "test",

  /**
   * User acceptance testing (UAT) environment
   */
  UAT = "uat",
}
